export const rightSideNavList = [
  { text: 'Assignments', link: '?name=assignments', query: { type: 'name', value: 'assignments' } },
  { text: 'Details', link: '?name=details', query: { type: 'name', value: 'details' } },
];
